//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ObsoleteInvoiceDisplayItem extends ItemBase {
    AmountDue: number | null = null;
    CreateDate: string = "1970-01-01T00:00:00";
    DownloadURL: string | null = null;
    DueDate: string | null = null;
    Emailed: boolean = false;
    EmailPending: boolean = false;
    EmailedDate: string | null = null;
    EndDate: string | null = null;
    FamilyID: number = 0;
    FamilyName: string | null = null;
    ID: number = 0;
    InvoiceEncodedID: string | null = null;
    InvoiceNumber: string | null = null;
    Note: string | null = null;
    Paid: boolean = false;
    ReminderDate: string | null = null;
    ReminderSent: boolean = false;
    ScheduledEmailDate: string | null = null;
    StartDate: string | null = null;
    StudentNames: string | null = null;
    ViewURL: string | null = null;
    Void: boolean = false;

    constructor(initializer?: Partial<ObsoleteInvoiceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ObsoleteInvoiceDisplayItem";
}
